/*
  Hero slider for sections/pf-hub-hero.liquid.

  One crossfade, nothing else. Auto-advances every 7 s until the visitor
  touches any control, then stops for good (clearInterval, not pause/resume:
  a slider that restarts under someone reading the label is worse than one
  that stays put). Under prefers-reduced-motion it never auto-advances and
  the CSS drops the fade.

  Slides carry data-hub-series/model/price/spec/url; the bar's output spans
  are data-hub-out-*, deliberately different names so a querySelector for
  one can never land on the other.
*/
(function () {
  'use strict';

  function init(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hub-slide]'));
    if (slides.length < 2) return;

    var link   = root.querySelector('[data-hub-link]');
    var series = root.querySelector('[data-hub-out-series]');
    var model  = root.querySelector('[data-hub-out-model]');
    var price  = root.querySelector('[data-hub-out-price]');
    var spec   = root.querySelector('[data-hub-out-spec]');
    var count  = root.querySelector('[data-hub-count]');
    var dots   = Array.prototype.slice.call(root.querySelectorAll('[data-hub-dot]'));
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === i);
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      dots.forEach(function (d, k) {
        if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      var s = slides[i];
      if (link)   link.href = s.getAttribute('data-hub-url') || '#';
      if (series) series.textContent = s.getAttribute('data-hub-series') || '';
      if (model)  model.textContent  = s.getAttribute('data-hub-model')  || '';
      if (price)  price.textContent  = s.getAttribute('data-hub-price')  || '';
      if (spec)   spec.textContent   = s.getAttribute('data-hub-spec')   || '';
      if (count)  count.textContent  = (i + 1) + ' / ' + slides.length;
    }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    root.querySelectorAll('[data-hub-prev]').forEach(function (b) {
      b.addEventListener('click', function () { stop(); show(i - 1); });
    });
    root.querySelectorAll('[data-hub-next]').forEach(function (b) {
      b.addEventListener('click', function () { stop(); show(i + 1); });
    });
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () { stop(); show(k); });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { stop(); show(i - 1); }
      if (e.key === 'ArrowRight') { stop(); show(i + 1); }
    });

    show(0);
    if (!reduce) timer = setInterval(function () { show(i + 1); }, 7000);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
  }

  function boot() { document.querySelectorAll('[data-hub-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
